import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-section-message',
  templateUrl: './section-message.component.html',
  styleUrls: ['./section-message.component.scss']
})
export class SectionMessageComponent implements OnInit {
  @Input() title: string = "";
  @Input() text: string = "";
  @Input() type: 'warning' | 'informative' | 'fapro' = 'informative';

  /**
   * FIN-1708 · an icon that overrides the one `type` implies. Absent, the three types
   * render exactly as they always have — which is what keeps the nine existing call
   * sites untouched.
   */
  @Input() icon: string;

  /** FIN-1708 · a right-aligned action. Absent, nothing is rendered. */
  @Input() actionLabel: string;

  @Output() actionClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

}
